<ion-button color="light" *ngIf="showBtn" [ngClass]="btnClass" (click)="print()" [disabled]="btnText === 'Printing...'">{{btnText}}</ion-button>